import React, { useEffect } from "react";
import Navbar from "./Navbar";
import FractionsText from "./commonTextPages/FractionsText";
import useResponsiveFlags from "../hooks/useResponsiveFlags";

export default function FractionsHome() {
  const { isDesktop } = useResponsiveFlags();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Navbar />
      <div
        style={{
          marginLeft: isDesktop ? "300px" : "0",
          paddingTop: isDesktop ? "" : "101px",
        }}
      >
        <FractionsText loggedin={true} />
      </div>
    </>
  );
}
